import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { SnotifyService } from 'ng-snotify';
import { AuthService } from '../../../../services/auth.service';
import { CompanyService } from '../../../../services/company.service';
import { Company } from '../../../../models/company';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-company-overview',
  templateUrl: './company-overview.component.html',
  styleUrls: ['./company-overview.component.scss']
})
export class CompanyOverviewComponent implements OnInit {
  filter: any = {
    companyId: undefined
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));
  loading: boolean = false;
  disableLocation: boolean = false;
  company: Company = undefined;
  user;
  companyName:string = '';
  messageBody:string = '';
  messageTitle:string = '';
  company_Id;
    companySaveTrigger: boolean = false;
  readOnly: boolean = false;
  constructor(private authService: AuthService, private snotifyService: SnotifyService, public router: Router, public companyService: CompanyService,public confirmationService :ConfirmationService) {
    this.user = this.authService.currentUser.value;
    if (this.authService.currentUser.value.userProfileId != 1&& this.authService.currentUser.value.userProfileId != 4) {
      this.readOnly = true;
    }

  }


  ngOnInit(): void {
    this.loading = true;
    this.company_Id = this.router.parseUrl(this.router.url).queryParams["id"];
    if (this.company_Id != null) {
      this.companyService.get(this.company_Id).then((c) => {
        this.company = c;
        this.companyName = c.name;
        this.messageTitle = c.messageTitle;
        this.messageBody = c.messageBody;
      }, (err) => {
        this.snotifyService.error("Error loading company details");
        this.loading = false;
        this.router.navigate(['']);

      });
    }
  }

  back() {
    this.confirmationService.confirm({
      message: 'Are you sure that you wish to go back?',
      accept: () => {
        this.router.navigate(['']);

      }
    });
  }

  saveMessage() {
//console.log(this.messageBody);
    this.companyService.updateMessage(this.company_Id,this.messageTitle,this.messageBody, this.user.id).then((c) => {
      this.snotifyService.success("successfully updated message");

    }, (err) => {
      this.snotifyService.error("Error updating message");

    });
  }

  companySave(company) {
    //console.log(company);
  }

   triggerCompanySave() {
    this.companySaveTrigger = !this.companySaveTrigger;
  }

  viewEquipment() {
    this.router.navigate(['admin/assets/'], { queryParams: { id: this.company_Id } });
  }
  viewLocation() {
    this.router.navigate(['admin/locations/'], { queryParams: { id: this.company_Id } });
  }
  inputInspection() {
    this.router.navigate(['admin/inspect/individual'], { queryParams: { id: this.company_Id } });
  }
  inputBulkInspection() {
    this.snotifyService.error("Not Yet Implemented")
  }
  
  uploadEquipment() {
   
    this.router.navigate(['admin/assets/upload'], { queryParams: { id: this.company_Id } });
  }
}
